import { background, blue, red, teal, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { JOB_TAG, JOB_TAG_LABEL } from "@/types/enum";
import { Chip, Stack, SxProps } from "@mui/material";
import dayjs from "dayjs";
import { FC } from "react";

export type TJobTagListProps = {
  tag?: string[] | null | undefined;
  createdAt?: string | null | undefined;
};

export const JobTagList : FC<TJobTagListProps> = ({ tag, createdAt }) => {
  const tagList = Array.isArray(tag) ? [...tag] : [];
  const baseStyles = {
    fontWeight: "700",
    fontSize: "12px",
    borderRadius: rounded.md,
  };

  const variantStyles: Record<string, SxProps> = {
    new: {
      bgcolor: blue[80],
      color: text.white,
    },
    urgent: {
      bgcolor: background.white,
      color: red[400],
      border: "1px solid",
      borderColor: red[400],
    },
    always_open: {
      bgcolor: background.white,
      color: teal[400],
      border: "1px solid",
      borderColor: teal[400],
    },
  };

  const getJobTag = (tag: string[], createdAtStr: string) => {
    const createdAt = dayjs(createdAtStr).format("YYYY-MM-DD");
    const numOfDiff: number = dayjs().diff(createdAt, "d");

    if (numOfDiff <= 14) {
      tag.push("new");
    }

    const uniqueTags = Array.from(new Set(tag));

    const order = Object.values(JOB_TAG);

    // short follow design
    return uniqueTags.sort((a, b) => {
      const indexA = order.indexOf(a);
      const indexB = order.indexOf(b);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });
  };

  const tags = createdAt && getJobTag(tagList, createdAt);

  if (!tags) return null;

  return (
    <Stack direction="row" spacing={1}>
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={JOB_TAG_LABEL[tag]}
          sx={{
              ...baseStyles,
              ...variantStyles[tag],
          }}
          />
      ))}
    </Stack>
  );
}
